import React from 'react'
import '../perfil.css';

function Profile() {

const ResetPassword=()=>{
    console.log("MAN")
}
const Handler=e=>{
    e.preventDefault();
    ResetPassword()
}
    return (
    <div className='User-Profile'>
        <div className='Foto-Perfil'>
        <img id='Perfil-img' src={require('./images/user.png')}  />
        <div id="colunaps">
        <div id="linhas">
                   
                        <div id="text">Usuario </div>
                        <div id="inpu"><input disabled="true" type="text" id="icart" name="icart"  value={localStorage.getItem('username')} required/></div>
                    </div>
                
                    <div id="linhas">
                     </div>
                     <div id="linhas">
                    </div>
                   
                    <div id="linhas">
                      </div>
                    <div id="linhas">
                       
                        <div id="text">Nivel:
                        </div>
                        <div id="inpu"><input disabled="true" type="text" id="icart" name="icart" value={localStorage.getItem('nivel')} required/></div>
                    </div>
                    
                    <div id='linhas'>
                        <div id="text">Idioma
                        </div>
     
                    <select id="inpu"   >
                            <option value="Ingles">Portugues</option>
                            <option value="Portugues">Ingles</option>
                           
                        </select>

                      </div>
                             <input type="submit" value="Sair"/>

                       
        </div>     
        </div>
        <div className='Info-Usuario'>
        <div id="colunaps">
               
        <label>Para redefinir a palavra , clique no botão </label>  
        <input type="submit" value="Reset Password" onClick={()=>window.location.pathname='/password-reset'}/>
                
        </div>     
       
        </div>
        </div>
  )
}

export default Profile